import ShipmentsTable from "./ShipmentsTable";
export default ShipmentsTable;
